<template>
    <ProSpaceVLayout v-if="bordered" class="home-dashboard-status" :gap="5" is-inline-h>
        <ProSpaceHLayout justify-content="space-between" :gap="5" style="height: auto;">
            <ProSpaceTag :type="tagType" :text="tagText" is-border-style big-height />
            <div class="home-dashboard-status__count" :class="getClasses" :title="formatDigit(count, null, 0)">
                {{ formatDigit(count, null, 0) }}
            </div>
        </ProSpaceHLayout>
        <div class="home-dashboard-status__label" :title="label">
            {{ label }}
        </div>
    </ProSpaceVLayout>
    <ProSpaceHLayout v-else class="home-dashboard-status" :gap="5" justify-content="space-between" is-inline-h>
        <ProSpaceVLayout :gap="5" style="height: auto;">
            <ProSpaceTag :type="tagType" :text="tagText" big-height/>
            <div class="home-dashboard-status__label">
                {{ label }}
            </div>
        </ProSpaceVLayout>
        <div class="home-dashboard-status__count" :class="getClasses" :title="formatDigit(count, null, 0)">
            {{ formatDigit(count, null, 0)}}
        </div>
    </ProSpaceHLayout>
</template>

<script>
import {
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceTag,
} from "@prospace/prospace-components-library";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";
export default {
    name: "HomeDashboardStatus",
    components: {
        ProSpaceHLayout,
        ProSpaceVLayout,
        ProSpaceTag
    },
    props: {
        tagType: {
            type: String,
            required: true
        },
        tagText: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        count: {
            type: Number,
            required: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        yellowBg: {
            type: Boolean,
            default: false
        },
        redBg: {
            type: Boolean,
            default: false
        },
        isBreakpoint: {
            type: Boolean,
            default: false
        },
        breakpoints: {
            type: Object,
            default: {
                start: null,
                current: null
            }
        }
    },
    computed: {
        getClasses() {
            return {
                'home-dashboard-status__count--empty': !this.count,
                'home-dashboard-status__count--yellow-bg': this.yellowBg && this.count,
                'home-dashboard-status__count--red-bg': this.redBg && this.count,
                'home-dashboard-status__count--overflow': this.count && (this.count).toString().length >= 5 && this.isWidthChanged
            }
        },
        isWidthChanged() {
            return (this.breakpoints?.current < this.breakpoints?.start) && (this.breakpoints?.current < 1300);
        }
    },
    methods: {
        formatDigit
    }
}
</script>

<style lang="scss">
.home-dashboard-status {
    padding: 10px;
    box-shadow: 0px 2px 10px rgba(51, 51, 51, 0.07);
    cursor: pointer;
    border-radius: 5px;
    margin: 0 10px;
    width: calc(100% - 20px) !important;
    &__count {
        font-size: 21px;
        font-weight: 500;
        line-height: 25px;
        color: var(--prospace-text-main);
        padding: 0 10px;
        border-radius: 5px;
        white-space: nowrap;
        &--empty {
            color: var(--prospace-ui-icon-gray);
        }
        &--yellow-bg {
            background-color: var(--prospace-ui-message-attention-bg);
        }
        &--red-bg {
            background-color: var(--prospace-block-red-secondary);
            color: var(--prospace-ui-red);
        }
        &--overflow {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    &__label {
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        color: var(--prospace-text-gray);
        @container (max-width: 1130px) {
          line-height: 12px;
          max-width: none;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
    }
    @media screen and (max-height: 800px) {
        padding: 5px 10px;
    }
  &--orders &__count {
    font-size: 19px;
  }
  &--orders-big &__count {
    padding-left: 0;
  }
  &--orders-big {
    .prospace-tag {
      max-width: 116px;
    }
  }
}
</style>
